<template>
  <OmtLayoutContainer>
    <OmtRow>
      <OmtButton
        mr="16px"
        size="sm"
        :variant="filtersCount > 0 ? 'solid' : 'outline'"
        leftIcon="sliders-h"
        :iconColor="filtersCount > 0 ? 'white' : 'var(--colors-light-primary-gray1)'"
        iconSize="sm"
        border=".5px solid var(--colors-light-secondary-divider)"
        :w="`${filtersCount > 0 ? 125 : 105}px !important`"
        @click="showFilterModal = true"
      >
        <OmtTypography
          as="button-small"
          :color="filtersCount > 0 ? 'white' : 'var(--colors-light-primary-gray1)'"
        >
          Filtrar
        </OmtTypography>
        <CBox
          v-show="filtersCount"
          ml="16px"
          bg="var(--colors-light-secondary-light-blue)"
          border-radius="12px"
          min-h="16px"
          min-w="16px"
          h="16px"
          w="16px"
          display="flex"
          justify-content="center"
          align-items="center"
        >
          <OmtTypography
            as="p2"
            color="white"
          >
            {{ filtersCount }}
          </OmtTypography>
        </CBox>
      </OmtButton>
      <SacListSortButtonVue
        :sorts="sorts"
        :initialValue="activedSort"
        @sort="saveSorts($event)"
      />

      <OmtButton
        variant="ghost"
        :disabled="!hasFilterOrSort"
        size="sm"
        w="105px !important"
        ml="auto"
        pr="0"
        @click="cleanSortsAndFilters"
      >
        Limpar
      </OmtButton>
    </OmtRow>
    <OmtRow
      v-for="complaint in filteredRequests"
      :key="complaint.protocol"
      mt="16px"
    >
      <SacListCard
        v-bind="complaint"
        @click="detailSac(complaint.protocol)"
      />
    </OmtRow>
    <FixedButtonRow>
      <OmtButton
        :w="['100%', '308px !important']"
        @click="createNewRequest"
        >Nova solicitação</OmtButton
      >
    </FixedButtonRow>

    <SacFilterModal
      v-if="showFilterModal"
      :filters="filters"
      @close="showFilterModal = false"
      @save="saveFilters"
    />
  </OmtLayoutContainer>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import SacListCard from "@/components/Organisms/Sac/SacListCard.vue";
import SacFilterModal from "@/components/Organisms/Sac/SacFilterModal.vue";
import SacListSortButtonVue from "@/components/Organisms/Sac/SacListSortButton.vue";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";

export default {
  name: "ListRequests",
  components: {
    SacListCard,
    SacFilterModal,
    SacListSortButtonVue,
    FixedButtonRow
  },
  data() {
    return {
      showSortModal: false,
      showFilterModal: false,
      sort: ""
    };
  },
  computed: {
    ...mapGetters("sac", ["filteredRequests"]),
    ...mapState("sac", ["filters", "complaints", "sorts", "activedSort", "successRequest"]),
    filtersCount() {
      return this.filters?.totalActived ?? 0;
    },
    hasFilterOrSort() {
      return this.filtersCount > 0 || this.activedSort !== "";
    }
  },
  methods: {
    ...mapActions("sac", ["fetchComplaints"]),
    ...mapMutations("sac", ["SET_FILTERS", "SET_SUCCESS_REQUEST", "SET_ACTIVED_SORT", "CLEAN_SORT_AND_FILTERS"]),
    cleanSortsAndFilters() {
      this.CLEAN_SORT_AND_FILTERS();
    },
    createNewRequest() {
      this.$router.push("/ouvidoria/criar/termo");
    },
    saveFilters(filters) {
      this.SET_FILTERS(filters);
    },
    saveSorts(sorts) {
      this.SET_ACTIVED_SORT(sorts);
    },
    displaySuccessToast() {
      if (this.successRequest) {
        this.$toast({
          description: "Sua solicitação foi enviada com sucesso",
          status: "success",
          duration: 5000,
          position: "top"
        });
        this.SET_SUCCESS_REQUEST(false);
      }
    },
    detailSac(protocol) {
      this.$router.push(`/ouvidoria/detalhe/${protocol}`);
    }
  },
  async mounted() {
    try {
      this.$root.$emit("show-loading");
      await this.fetchComplaints({ force: this.successRequest });
    } catch (error) {
      console.error(error);
    } finally {
      this.$root.$emit("hide-loading");
      if (this.successRequest) this.displaySuccessToast();
    }
  }
};
</script>
